import React, { useEffect, useState } from "react";
import * as api from "../constant/API";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

const Profile = () => {

    const [details, setDetails] = useState([]);
    const [oldPwd, setOldPwd] = useState('');
    const [newPwd, setNewPwd] = useState('');
    const [cnfmNwPwd, setCnfmNwPwd] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [pwdError, setPwdError] = useState('');
    const [instId, setInstId] = useState<string | null>(null);

    const roleId = localStorage.getItem('RoleId');
    if (roleId == 8) {
        const ins = localStorage.getItem('InstitutionId');
        setInstId(ins)
    }

    useEffect(() => {
        getProfileDetails();
    }, [])

    function getProfileDetails() {
        let getDetails = api.ProfileDetails;
        if (roleId == 8) {
            getDetails += '/' + instId;
        }
        fetch(getDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setDetails(result.data)
                } else {
                    Swal.fire(result.message)
                }
            })
    }

    function changePwd() {
        if (!pwdError) {


            const formData = new FormData();
            formData.append('roleId', roleId)
            formData.append('instituteId', instId)
            formData.append('currentPassword', oldPwd)
            formData.append('newPassword', newPwd)
            formData.append('confirmPassword', cnfmNwPwd)

            const changePassWord = api.ChangePassword;
            fetch(changePassWord, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire(result.message)
                        setOpenModal(false)
                    } else {
                        setPwdError(result.message)
                    }
                })
        }
    }

    const validatePasswords = (pwd, confirmPwd) => {
        if (pwd && confirmPwd && pwd !== confirmPwd) {
            setPwdError("Passwords do not match!");
        } else {
            setPwdError("");
        }
    };
    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items">
                                <div className="col-lg-6">
                                    <h4 className="mb-40">Profile</h4>
                                </div>
                                <div className="col-lg-6 text-end">
                                    <Button
                                        className="btn-secondary me-3 text-uppercase"
                                        variant="success"
                                        onClick={() => setOpenModal(true)}
                                    >
                                        <i className="fas fa-key" />&nbsp;
                                        Change Password
                                    </Button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="col-lg-6">
                                                            <table className="col-lg-12">
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <td><h6>{details.internalUserFirstName + ' ' + details.internalUserLastName}</h6></td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Role</th>
                                                                    <td><h6>{details.roleName}</h6></td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="md"
                centered
                onHide={() => setOpenModal(false)}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="text-uppercase text-center"><i className="fas fa-key" />Change Password</h4>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Current Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="crntPwd"
                            value={oldPwd}
                            onChange={(e) => setOldPwd(e.target.value)}
                            placeholder="Current Password"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="newPwd"
                            value={newPwd}
                            onChange={(e) => setNewPwd(e.target.value)}
                            placeholder="New Password"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="cnfmPwd"
                            value={cnfmNwPwd}
                            onChange={(e) => { setCnfmNwPwd(e.target.value); validatePasswords(newPwd, e.target.value) }}
                            placeholder="Confirm Password"
                        />
                    </div>

                    {pwdError && <div className="alert alert-danger">{pwdError}</div>}

                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={() => { changePwd(); setOpenModal(false) }}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" /> Save</b>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default Profile;